module.exports = __webpack_public_path__ + "img/en2.218f936f.png";